import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lib-full-page-popup-layout',
  imports: [RouterLink],
  templateUrl: './full-page-popup-layout.html',
  styleUrl: './full-page-popup-layout.scss',
})
export class FullPagePopupLayout {}
